import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { usersApis } from '../../constants/users-api';
import { HttpClient } from '@angular/common/http';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';
import { PaginationType } from '../../interfaces/pagination/pagination-type';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    callListOfUploadedDocs = new BehaviorSubject<boolean>(false);
    callListOfUploadedDocs$ = this.callListOfUploadedDocs.asObservable();
    permissions_entity = permissionEntity;
    callListOfLeaves = new BehaviorSubject<boolean>(false);
    callListOfLeaves$ = this.callListOfLeaves.asObservable();

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe // dont remove this
    ) { }

    getUsersList(pagination: any, type?: string, filters?: any, search?: string, sort: { sortDataOption: string, sortDataOrder: string } = null): Observable<any> {
        let query = '?';
        if (type) {
            if (type === 'urm') {
                query += 'urm=true&';
                query += 'status=true&'
            } else if (type === 'rm') {
                query += 'rm=true&';
                query += 'status=true&'
            }
            else {
                query += 'urm=true&';
                query += 'status=true&'
            }
        }
        if (filters) {
            query += filters;
        }
        if (search) {
            query += `name=${search}&`;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.users);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(`${usersApis.getUsersList}${query}`);
    }

    getCaseOwner(pagination: any, type?: string, filters?: any, search?: string, sort: { sortDataOption: string, sortDataOrder: string } = null): Observable<any> {
        let query = '?';
        // if (type) {
        //     query += `usertype=${type}&`
        // }
        if (filters) {
            query += filters;
        }
        if (search) {
            query += `name=${search}&`;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.users);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${usersApis.caseownerV2}${query}`);
    }
    getCaseOwnerV3(pagination: any, search?: string, sort: { sortDataOption: string, sortDataOrder: string } = null): Observable<any> {
        let query = '?';
        // if (type) {
        //     query += `usertype=${type}&`
        // }
        // if (filters) {
        //     query += filters;
        // }
        if (search) {
            query += `name=${search}&`;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(this, this.permissions_entity.modules.users);
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${usersApis.caseownerV3}${query}`);
    }

    postUsers(payload: any): Observable<any> {
        return this.httpClientService.post(usersApis.createUser, payload);
    }

    updateUsers(id: string, payload: any): Observable<any> {
        const url = `${usersApis.updateUser}?Id=${id}`;
        return this.httpClientService.put(url, payload);
    }

    deleteUser(id: string): Observable<any> {
        return this.httpClientService.delete(
            usersApis.deleteUsers.replace(':userId', id)
        );
    }

    getUserById(id: string): Observable<any> {
        return this.httpClientService.get(
            usersApis.getUserById.replace(':userId', id)
        );
    }

    uploadDocById(id: string, payload: any): Observable<any> {
        const url = `${usersApis.uploadDocumentById}?userId=${id}`;
        return this.httpClientService.upload(url, payload);
    }
    removeDocById(payload: any): Observable<any> {
        const url = `${usersApis.removeDocumentById}`;
        return this.httpClientService.post(url, payload);
    }

    getUsersListFilter(params: {
        skip: number; limit: number; email: string, roleId?; status; twoFactorAuth;
        jobRoleId; employeeCabinId; name; employeDesignation?
    }): Observable<any> {
        let url = `${usersApis.getUsersList}?`;
        // console.log(params);

        // Create a new instance of URLSearchParams
        const searchParams = new URLSearchParams();

        // Add parameters to the URLSearchParams if they are defined
        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined) {
                searchParams.set(key, value);
            }
        }

        // Append the URLSearchParams to the URL
        // url += `&${searchParams.toString()}`;
        url += `${searchParams.toString()}`;
        return this.httpClientService.get(url);
    }

    resendInvite(id: string): Observable<any> {
        return this.httpClientService.post(usersApis.resendInvite.replace(':userId', id), {});
    }

    verifyEmailForDomain(payload: any): Observable<any> {
        return this.httpClientService.post(usersApis.verifyEmailForDomain, payload);
    }

    fetchUserInventoryService(userId: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchUserInventory + userId);
    }

    fetchUserLeaveCommentService(userId: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchUserLeaveComment + userId);
    }

    fetchUserAttendanceService(userId: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchUserAttendance + userId);
    }

    fetchUserSalaryService(userId: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchSalaryDetails + userId);
    }

    fetchUserSalaryGenerateService(userId: any, dateObj: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchSalarySlipDetails + userId + `&month=${dateObj?.month}&year=${dateObj?.year}`);
    }

    fetchUserSalaryDownloadService(userId: any, dateObj: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchSalarySlipDownload + userId + `&month=${dateObj?.month}&year=${dateObj?.year}`);
    }

    fetchUserLeaveHolidayService(): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchUserLeaveHoliday);
    }

    fetchUserLeaveCommentLogService(userId: any): Observable<any> {
        return this.httpClientService.getPhp(usersApis.fetchUserLeaveLog + userId);
    }

    applyLeaveComment(id: string, payload: any): Observable<any> {
        return this.httpClientService.post(
            usersApis.applyLeaveComment,
            payload
        );
    }

    attendanceComment(id: string, payload: any): Observable<any> {
        return this.httpClientService.post(
            usersApis.attendanceComment,
            payload
        );
    }

    attendanceHoliday(id: string, payload: any): Observable<any> {
        return this.httpClientService.post(
            usersApis.attendanceHoliday,
            payload
        );
    }

    // fetchUserCallList(pagination: any,): Observable<any> {
    //     let query = '?';
    //     query += `skip=${pagination.skip}&limit=${pagination.limit}`;

    //     return this.httpClientService.getPhp(`${usersApis.fetchUserCallList}${query}`);
    // }
    fetchUserCallList(pagination: any, username?: string, university?: string,jobrole?: string): Observable<any> {
        let query = '?';
        if(username){
            query +=`username=${username}&`
        }
        if(university){
            query +=`university=${university}&`
        }
        if(jobrole){
            query +=`jobrole=${jobrole}&`
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(`${usersApis.fetchUserCallList}${query}`);
    }

    makeCall(payload: any): Observable<any> {
        return this.httpClientService.post(`${usersApis.agentMakeCall}`, payload);
    }

    // extboundCall(payload: any, token: any): Observable<any> {
    //     return this.httpClientService.post(`${usersApis.extMakeCall}?token=${token}`, payload);
    // }
    extboundCall(payload: any): Observable<any> {
        return this.httpClientService.post(`${usersApis.extMakeCall}`, payload);
    }

    extboundLogin(payload: any): Observable<any> {
        return this.httpClientService.post(`${usersApis.extMakeLogin}`, payload);
    }

    // outboundCall(payload: any, token: any): Observable<any> {
    //     return this.httpClientService.post(`${usersApis.extMakeOutBoundCall}?token=${token}`, payload);
    // }
    outboundCall(payload: any): Observable<any> {
        return this.httpClientService.post(`${usersApis.extMakeOutBoundCall}`, payload);
    }
    getCommissionForFilters(universityCountryId?): Observable<any> {
        let query = '&';
        if (universityCountryId) {
            query += `universityCountryId=${universityCountryId}`;
        }
        return this.httpClientService.getPhp(`${usersApis.crizacCommission}${query}`);

    }
    getCommission(
        pagination: PaginationType,
        manufactureId: string = '',
        intakeName: string = '',
        destinationCountryId: string = '',
        universityCountryId: string = '',
        promotion: number = 0
    ): Observable<any> {
        let query = '&';
        query += `skip=${pagination.skip}&limit=${pagination.limit}&promotion=${promotion}`;
        if (manufactureId) {
            query += `&manufactureId=${manufactureId}`;
        }
        if (intakeName) {
            query += `&intakeName=${intakeName}`;
        }
        if (destinationCountryId) {
            query += `&destinationCountryId=${destinationCountryId}`;
        }
        if (universityCountryId) {
            query += `&universityCountryId=${universityCountryId}`;
        }
        return this.httpClientService.getPhp(
            `${usersApis.crizacCommission}${query}`
        );
    }
    ucolCommissionForFilters(): Observable<any> {

        return this.httpClientService.getPhp(`${usersApis.ucolCommission}`);

    }
    ucolCommission(
        pagination: PaginationType,
        manufactureId: string = '',
        intakeName: string = '',
        destinationCountryId: string = '',
        universityCountryId: string = '',
        promotion: number = 0
    ): Observable<any> {
        let query = '&';
        query += `skip=${pagination.skip}&limit=${pagination.limit}&promotion=${promotion}`;
        if (manufactureId) {
            query += `&manufactureId=${manufactureId}`;
        }
        if (intakeName) {
            query += `&intakeName=${intakeName}`;
        }
        if (destinationCountryId) {
            query += `&destinationCountryId=${destinationCountryId}`;
        }
        if (universityCountryId) {
            query += `&universityCountryId=${universityCountryId}`;
        }
        return this.httpClientService.getPhp(
            `${usersApis.ucolCommission}${query}`
        );
    }
    marketingUserlist(id,pagination: PaginationType,): Observable<any> {
        let query = '&'
        query += `skip=${pagination.skip}&limit=${pagination.limit}`
        return this.httpClientService.get(`${usersApis.marketingUserList}${id}${query}`);
    }
    searchAgent(): Observable<any> {
        return this.httpClientService.get(`${usersApis.searchAgent}`);
    }
    refferedBy(pagination: PaginationType,): Observable<any> {
        let query = '?'
        query += `skip=${pagination.skip}&limit=${pagination.limit}`
        return this.httpClientService.get(`${usersApis.refferedBy}${query}`);
    }
    fetchUserWFHService(pagination: PaginationType): Observable<any> {
        let query = '?'
        query += `skip=${pagination.skip}&limit=${pagination.limit}`
        return this.httpClientService.get(`${usersApis.fetchUseWFHService}${query}`);
    }
    createWFH(payload: any): Observable<any> {
        return this.httpClientService.post(
            usersApis.createWFH,
            payload
        );
    }
}
